import React, {useState, useRef, useEffect} from 'react';
import './InputAvatar.css';
import cfg, {formatErrors} from "../../constants";
import {toast} from "react-toastify";

export function InputAvatar({id, image = '', handleUpdate, handleChange}) {
  const [value, setValue] = useState('');
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const refInput = useRef(null);

  const handleFileSelected = (e) => {
    const file = e.target.files && e.target.files.length > 0 ? e.target.files[0] : null;
    setFile(file);
    setValue('');
    setLoading(true);
  };

  const onRemove = () => {
    setLoading(true);
    handleUpdate(id, null).then(() => {
      handleChange('');
      setLoading(false);
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  useEffect(() => {
    if (file) {
      handleUpdate(id, file).then((res) => {
        handleChange(res.id);
        setLoading(false);
      }).catch((e) => {
        setLoading(false);
        setFile(null);
        toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file]);

  return <label className={"upload-file" + (loading ? " upload-file--loading" : "")}>
    <input type="file"
           ref={refInput}
           className="upload-file__input"
           accept=".jpg, .jpeg, .png"
           disabled={loading}
           value={value}
           onChange={handleFileSelected}
    />
    {image !== '' && !loading && <img src={cfg.public_url + 'auth/file/' + id + '/i/' + image} alt="" className="profile__ava" />}
    {image && !loading && <span className="upload-file__btn upload-file__btn--remove icon-delete" onClick={onRemove}></span>}
    {!image && !loading && <span className="upload-file__btn">+ фото</span>}
  </label>;
}
